<script lang="ts">
	import PostMessageHelper from './helpers/PostMessageHelper';
	import Widget from './components/Widget.svelte';
	import ButtonAvatar from './components/ButtonAvatar.svelte';
	import type WidgetOptions from './models/WidgetOptionsModel';
	import type { Command } from './models/CommandModel';
	import isPhoneSize from './helpers/IsPhoneSize';
	import SubscribeOnEvents from './helpers/SubscribeOnEvents';
	import {onMount} from "svelte";
	import {loop_guard} from "svelte/internal";

	export let widgetOptions: WidgetOptions;

	let isWidgetOpenedAsPopup = false;
	let isWidgetOpened = false;
	let widgetHeight: number = 0;
	let isBotTyping = false;
	let isPulsarAnimation = false;

	PostMessageHelper.subscribeOnMessages(handleMessage, widgetOptions.url);

	// возвращает куки с указанным name,
	// или undefined, если ничего не найдено
	function getCookie(name) {
		let matches = document.cookie.match(new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	// Iframe url
	const cookie = getCookie('_ym_uid');
	const IframeWebBotUrl = `${widgetOptions.url}/${
		widgetOptions.survey_id
	}?widget_id=${widgetOptions.widget_id}&_ym_uid=${cookie}#${encodeURIComponent(
		document.location.href
	)}`;

	function toggleWidget(): void {
		isWidgetOpened = !isWidgetOpened;
		if (!isWidgetOpened) {
			widgetHeight = 0;
			isWidgetOpenedAsPopup = false;
		}

		PostMessageHelper.postMessage({
			name: 'toggleWidget',
			payload: {
				isWidgetOpened,
				isPhoneSize: isPhoneSize()
			}
		});
	}

	// Getting message from chat
	function handleMessage(message: { data: Command }): void {
		if (!message.data) {
			return;
		}
		const command = message.data;
		switch (command.name) {
			case 'togglePopup':
				isWidgetOpenedAsPopup = !isWidgetOpenedAsPopup;
				break;
			case 'changeHeight':
				widgetHeight = command.payload.height;
				break;
			case 'close':
				// This command may come only if widget open, so
				// we call toggleWidget, because it always close widget
				isWidgetOpenedAsPopup = false;
				toggleWidget();
				break;
			case 'openWidget':
				// If we open widget - we don't show preview any more
				// until we get new message
				toggleWidget();
				break;
			case 'closePreviewTrigger':
				widgetHeight = 0;
				break;
			case 'typing':
				isBotTyping = command.payload.isBotTyping;
				break;
			case 'makeSound':
				const soundPath = command.payload.soundPath;
				if (soundPath) {
					makeSound(soundPath);
				}
				break;
			case 'events':
				SubscribeOnEvents(command.payload.events);
				break;
			case 'isPulsar':
				isPulsarAnimation = command.payload.isPulsar;
				break;
		}
	}

	function makeSound(soundPath: string): void {
		const path = widgetOptions.url + soundPath;

		const sound = new Audio(path);

		sound.play().catch((e) => console.log(e));
	}

	// Получение куки roistat_visit
	function getRoistatVisitCookie(attempt) {
		const roistatVisitValue = getCookie('roistat_visit')

		if (!attempt || roistatVisitValue) {
			PostMessageHelper.postMessage({
				name: 'roistatVisit',
				payload: {
					cookie: { name: 'roistat_visit', value: roistatVisitValue }
				}
			});
			return
		}
		setTimeout(() => {
			getRoistatVisitCookie(attempt - 1)
		}, 5000)
	}


	onMount(() => {
		setTimeout(() => getRoistatVisitCookie(3), 2000);

	});
</script>

<Widget
	src={IframeWebBotUrl}
	isPopup={isWidgetOpenedAsPopup}
	height={widgetHeight}
	{isWidgetOpened}
/>

<ButtonAvatar
	avatar={widgetOptions.avatar}
	color={widgetOptions.bg_color}
	isVideoAvatar={widgetOptions.isVideoAvatar}
	activatedPulsar={isPulsarAnimation}
	{isWidgetOpened}
	typing={isBotTyping}
	on:click={toggleWidget}
/>
